export function customSum(values: number[]) {
    let foundNonNull = false;

    const sum = values.reduce((acc, value, i, a) => {
        if (value != null) {
            foundNonNull = true;
        }
        return acc + value;
    }, 0);

    return foundNonNull ? sum : null;
}

// If all values are null, return null
export function customAvg(values: number[]) {
    let foundNonNull = false;

    const sum = values.reduce((acc, value, i, a) => {
        if (value != null) {
            foundNonNull = true;
        }
        return acc + value;
    }, 0);
    return foundNonNull ? sum / values.filter(v => v != null).length : null;
}